// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__21rTK","name":"ConsentHeader_name__3Mb9E","birthday":"ConsentHeader_birthday__joiMu","skeleton":"ConsentHeader_skeleton__2eid2"};